import { render, staticRenderFns } from "./ModalTurma.vue?vue&type=template&id=fce1ac06&"
import script from "./ModalTurma.vue?vue&type=script&lang=js&"
export * from "./ModalTurma.vue?vue&type=script&lang=js&"
import style0 from "./ModalTurma.vue?vue&type=style&index=0&id=fce1ac06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports